// extracted by mini-css-extract-plugin
export default {"container":"style_container__NA3GM","header":"style_header__Dazrb","content":"style_content__O8N7A","questions":"style_questions__N2a9a"};